import { brown, deepPurple, teal } from '@mui/material/colors';
import { themeColors } from '../JuvareTheme';
let convertDeprecatedColorsToSupportedColors = true;
/**
 * Sets the internal flag that determines whether deprecated card colors
 * should be converted to supported colors.
 * @param {boolean} flag - If true, enables conversion of deprecated colors.
 */
export function setConvertDeprecatedColorsToSupportedColors(flag) {
    convertDeprecatedColorsToSupportedColors = flag;
}
/**
 * Returns the appropriate set of card colors based on the
 * convertDeprecatedColorsToSupportedColors flag.
 * @returns {typeof cardColors | typeof cardColorsConverted} The selected card color set.
 */
export function getCardColors() {
    return convertDeprecatedColorsToSupportedColors ? cardColorsConverted : cardColors;
}
export const cardColors = {
    // New supported decorative colors.
    pink: themeColors.decorative.pink,
    red: themeColors.decorative.red,
    orange: themeColors.decorative.orange,
    green: themeColors.decorative.green,
    blue: themeColors.decorative.blue,
    purple: themeColors.decorative.purple,
    cyan: themeColors.decorative.cyan,
    // No longer supported colors.
    /**
     * @deprecated Do not use this color, pick one of the supported decorative colors.
     */
    grey: themeColors.accent.grey.base,
    /**
     * @deprecated Do not use this color, pick one of the supported decorative colors.
     */
    black: themeColors.decorative.black,
    // Deprecated colors
    /**
     * @deprecated Use purple instead.
     */
    deepPurple: deepPurple[500],
    /**
     * @deprecated Use cyan instead.
     */
    teal: teal[500],
    /**
     * @deprecated Use orange instead.
     */
    yellow: '#FFC107',
    /**
     * @deprecated Use orange instead.
     */
    brown: brown[500],
};
export const cardColorsConverted = Object.assign(Object.assign({}, cardColors), { grey: cardColors.blue, black: cardColors.blue, deepPurple: cardColors.purple, teal: cardColors.cyan, yellow: cardColors.orange, brown: cardColors.orange });
